import React from 'react';
import { connect } from 'react-redux';
import Chat from './constructorComponents/chat';
import { channelOfMessage } from './constructorComponents/chat/channels';
import AnimList from './features/animList';
import Constructor from './constructor';
import SkillsMenu from './features/skillsMenu';
import TestMenu from './features/testMenu';
import AuthPanel from './components/AuthPanel/AuthPanel';
import BrandSplash from './components/BrandSplash/BrandSplash';
import CitySelection from './components/CitySelection';
const DICE_COMMAND_REGEXP = /^\/(\d+)d(\d+)$/i;

// Returns a French roll-result message for "/NdM" dice commands (e.g. "/1d6", "/2d20"),
// or null if the message isn't a dice command.
function rollDiceMessage(msg) {
  const match = msg.trim().match(DICE_COMMAND_REGEXP);
  if (!match) return null;

  const count = parseInt(match[1], 10);
  const sides = parseInt(match[2], 10);
  if (!(count >= 1 && count <= 100 && sides >= 2)) return null;

  const rolls = Array.from({ length: count }, () => 1 + Math.floor(Math.random() * sides));

  if (sides === 2 && count === 1) {
    return `Lancement d'une pièce, résultat : ${rolls[0] === 1 ? 'Pile' : 'Face'}`;
  }

  if (count === 1) {
    return `Lancement d'un dé ${sides}, résultat : ${rolls[0]}`;
  }

  const total = rolls.reduce((sum, roll) => sum + roll, 0);
  return `Lancement de ${count} dés ${sides}, résultats : ${rolls.join(', ')} (total : ${total})`;
}

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoggined: false,
      widgets: this.props.elem || null,
      authState: null,
      brandSplash: null,
    };
  }
  componentDidMount() {
    window.addEventListener('focus', this.onWindowFocus.bind(this));
    window.addEventListener('blur', this.onWindowFocus.bind(this));
    window.mp = {
      send: (type, data) => {
        try {
          window.skymp.send({ type, data });
        } catch {
          console.log(type, data);
        }
      }
    };
    try {
      window.skymp.on('error', console.error);
      window.skymp.on('message', (action) => { window.storage.dispatch(action); });
    } catch { }
    window.isMoveWindow = false;
    window.addEventListener('mousemove', this.onMoveWindow);
    window.addEventListener('mouseup', this.onMouseUp);
    window.skyrimPlatform.widgets.addListener(this.handleWidgetUpdate.bind(this));
    this.onChatMessage = this.onChatMessage.bind(this);
    window.addEventListener('skymp5-client:chatMessage', this.onChatMessage);
    this.onAuthState = this.onAuthState.bind(this);
    window.addEventListener('skymp5-client:authState', this.onAuthState);
    this.onBrandSplash = this.onBrandSplash.bind(this);
    window.addEventListener('skymp5-client:splash', this.onBrandSplash);
    this.logChatDebugInfo();
  }
  onAuthState(event) {
    this.setState({ authState: event.detail || null });
  }
  // The client keeps the Altherys splash up while the game loads the world, over the game's own loading screen.
  onBrandSplash(event) {
    const detail = event.detail;
    this.setState({ brandSplash: detail && detail.visible ? detail : null });
  }
  copyToClipboard(value) {
    // CEF-friendly clipboard write: navigator.clipboard needs a secure
    // context/permission that the in-game browser may not grant, so fall
    // back to the classic hidden-textarea + execCommand trick.
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(value).catch(() => {});
      }
    } catch (e) { /* ignore */ }
    try {
      const ta = document.createElement('textarea');
      ta.value = value;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
      return true;
    } catch (e) {
      return false;
    }
  }
  onChatMessage(event) {
    const { sender, text, kind, global } = event.detail || {};
    if (!text) return;

    // "/here" answers with a locationalData JSON snippet meant to be pasted
    // into startCities.json / teleportPoints — put it in the clipboard so the
    // admin doesn't have to retype it from the chat.
    let copiedSuffix = '';
    if (kind === 'do' && text.includes('"cellOrWorldDesc"')) {
      if (this.copyToClipboard(text)) copiedSuffix = ' 📋 copié !';
    }

    let displayedText;
    let color;
    switch (kind) {
      case 'me':
        displayedText = `${sender} ${text}`;
        color = '#c9a0ff';
        break;
      case 'do':
        displayedText = `:: ${text}${copiedSuffix} (${sender}) ::`;
        color = '#9a9a9a';
        break;
      case 'dice':
        displayedText = `${sender}: ${text}`;
        color = '#ffd866';
        break;
      default:
        displayedText = `${global ? '[Global]' : '[Local]'} ${sender}: ${text}`;
        color = global ? '#7dd3fc' : '#ffffff';
    }

    window.storage.dispatch({
      type: 'ADD_CHAT_MSG',
      // category must NOT be 'plain': the chat component's hors-rp filter
      // treats category === 'plain' as "this message is non-RP" and hides
      // it entirely when the hors-rp checkbox is checked.
      // channel decides which chat tab shows the line and which one gets the unread badge
      data: { text: [{ text: displayedText, color, opacity: 1, type: kind === 'me' || kind === 'do' ? ['italic'] : [] }], category: 'rp', channel: channelOfMessage(sender, !!global) }
    });
  }
  logChatDebugInfo() {
    const send = window.skyrimPlatform?.sendMessage;
    if (!send) return;
    // Wait a tick so #chat has actually been laid out by the browser.
    setTimeout(() => {
      const chatNode = document.getElementById('chat');
      const rect = chatNode ? chatNode.getBoundingClientRect() : null;
      send(`chat-debug:App mounted, isLoggined=${this.state.isLoggined}, widgets=${this.state.widgets ? this.state.widgets.length : 'null'}, chatList.length=${(this.props.chatList || []).length}, chatShowInput=${this.props.chatShowInput}, #chat found=${!!chatNode}, rect=${JSON.stringify(rect)}, window.innerSize=${window.innerWidth}x${window.innerHeight}`);
    }, 0);
  }
  handleWidgetUpdate(newWidgets) {
    this.setState({ ...this.state, widgets: newWidgets });
    this.logChatDebugInfo();
  }
  componentWillUnmount() {
    window.removeEventListener('focus', this.onWindowFocus.bind(this));
    window.removeEventListener('blur', this.onWindowFocus.bind(this));
    window.removeEventListener('skymp5-client:chatMessage', this.onChatMessage);
    window.removeEventListener('skymp5-client:authState', this.onAuthState);
    window.removeEventListener('skymp5-client:splash', this.onBrandSplash);
    window.addEventListener('mousemove', this.onMoveWindow);
    window.skyrimPlatform.widgets.removeListener(this.handleWidgetUpdate.bind(this));
  }
  onWindowFocus(e) { this.props.updateBrowserFocus(document.hasFocus()); }
  onMoveWindow(e) {
    if (window.isMoveWindow && typeof window.moveWindow === 'function') {
      window.moveWindow(e.clientX, e.clientY);
    }
  }
  onMouseUp() {
    if (window.isMoveWindow) window.isMoveWindow = false;
    window.moveWindow = null;
  }
  renderLoginPanel() {
    const splash = this.state.brandSplash;
    return (
      <>
        <AuthPanel authState={this.state.authState} />
        {splash ? <BrandSplash who={splash.who} status={splash.status} /> : null}
      </>
    );
  }
  render() {
    const loginPanel = this.renderLoginPanel();
    const chatEl = (
      <Chat
        isInputHidden={!this.props.chatShowInput}
        messages={this.props.chatList}
        visibilityMode={this.props.chatVisibilityMode}
        setVisibilityMode={(mode) => window.storage.dispatch({ type: 'UPDATE_CHAT_VISIBILITY_MODE', data: mode })}
        send={(msg, isHrp) => {
          const diceResult = rollDiceMessage(msg);
          const finalText = diceResult || msg;
          if (!window.skyrimPlatform?.sendMessage) {
            console.log('chat (no game client connected):', finalText);
            return;
          }
          window.skyrimPlatform.sendMessage('chat-send:' + JSON.stringify({
            text: finalText,
            scope: isHrp ? 'global' : 'local'
          }));
        }}
        placeholder="Appuyez sur Entree..."
      />
    );
    if (this.state.isLoggined) {
      return (
        <div className={`App ${!window.hasOwnProperty('skyrimPlatform') ? 'bg' : ''}`}>
          <AnimList />
          {loginPanel}
          {chatEl}
          <SkillsMenu />
          <TestMenu />
        </div>
      );
    } else if (this.state.widgets) {
      return (
        <div style={{ position: 'static' }}>
          {loginPanel}
          {chatEl}
          {this.state.widgets.map((widget, index) =>
            <Constructor
              key={index.toString() + widget.type + ((widget.type === 'form') ? widget.elements + widget.caption : 'chat')}
              dynamicSize={true}
              elem={widget}
              height={this.props.height || 704}
              width={this.props.width || 512} />
          )}
        </div>
      );
    } else {
      return (
        <div style={{ position: 'static' }}>
          {loginPanel}
          {chatEl}
        </div>
      );
    }
  }
}
const mapStateToProps = (state) => ({
  isBrowserFocus: state.appReducer.isBrowserFocus,
  chatList: state.chatReducer.list,
  chatShowInput: state.chatReducer.showInput,
  chatVisibilityMode: state.chatReducer.visibilityMode
});
const mapDispatchToProps = (dispatch) => ({
  updateBrowserFocus: (data) => dispatch({ type: 'UPDATE_APP_BROWSERFOCUS', data })
});
export default connect(mapStateToProps, mapDispatchToProps)(App);